import ReactGA from "react-ga";

const useGAEventsTracker = (categorie = "Event Category") => {
  const trackEvent = (action = "action", label = "label") => {
    ReactGA.event(categorie, action, label);
  };
  return trackEvent;
};
export default useGAEventsTracker;
